import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../translate';

function Maps({ address, size, zoom }) {
  const { location } = address;
  const [longitude, latitude] = location;

  const center = address.address || '';
  const a = center.replace(/ /g, '+');
  const b = a.split(',+').join(',');

  return (
    <div className="session-more-information">
      <div
        className={cx('session-info-extra')}
      >
        <div className="row">
          <div id="map" className="col-lg-12">
            <img
              // eslint-disable-next-line max-len
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${b}&zoom=${zoom}&size=${size.width}x${size.height}&maptype=roadmap&markers=color:red%7Clabel:%7C${latitude},${longitude}&key=AIzaSyDalDJYhVtS9zESl6OHGxWgJiBeI6Otiho`}
              alt="Google Maps"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

Maps.propTypes = {
  address: PropTypes.shape({
    location: PropTypes.arrayOf([]).isRequired,
    address: PropTypes.string.isRequired,
  }).isRequired,
  size: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
  zoom: PropTypes.number,
};

Maps.defaultProps = {
  size: {
    width: 600,
    height: 400,
  },
  zoom: 13,
};

export default translate(Maps);
